import type { ApiConfig } from '../../types'

export const spotTradeHistoryApiConfig = {
  existSubType: true,
  fetchableRange: undefined,
  limit: 1000,
  order: 'desc',
  range: undefined,
  requestDelay: 500, // レートリミット対策 (SPOT)
  requiresRange: false,
  type: 'spot-trade-history',
} as const satisfies ApiConfig
